<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-form @submit.prevent="approve">
          <display-preview :data-review="detail" />
          <popup />
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BForm,
} from 'bootstrap-vue'
import DisplayPreview from '@/views/page/campaign/detail/Preview.vue'
import { mapGetters, mapMutations } from 'vuex'
import Popup from '@/views/component/PopupCampaign.vue'

export default {
  components: {
    DisplayPreview,
    BRow,
    BCol,
    BCard,
    BForm,
    Popup,
  },
  data() {
    return {
      detail: {},
      // internal: this.$store.state.auth.userData.data.company.internal_company,
    }
  },
  computed: {
    ...mapGetters('campaign', {
      dataCampaignItem: 'getCampaignManageItem',
      campaignId: 'getCampaignId',
    }),
  },
  beforeMount() {
    this.setCampaignId(this.$route.params.id)
    // eslint-disable-next-line radix
    this.getDetail(this.campaignId)
  },
  methods: {
    ...mapMutations('campaign', {
      setCampaignId: 'SET_CAMPAIGN_ID',
    }),
    getDetail(id) {
      const campaigns = this.dataCampaignItem.data
      const dataCampaign = campaigns.find(item => item.campaign_id === id)
      this.detail = dataCampaign
      // console.log(id, this.detail, campaigns, 'response')
    },
    goPage(url) {
      this.$router.push({ name: url })
    },
  },
}
</script>
